import logo from './logo.svg';
import './App.css';

import {createBrowserRouter, Navigate, Route, RouterProvider, Routes} from 'react-router-dom'
import Home from './components/Home/Home';
import Lobby from './components/Lobby/Lobby'
import WsContainer from './components/WsContainer';
import {store} from './store/store'
import { Provider } from 'react-redux';
import Marjan from './components/Game/GameBoard';
import OfflineGame from './components/Game/OfflineGame';
import RouteProtector from './components/RouteProtector';
import Leaderboard from './components/Leaderboard/Leaderboard';
import ZNKTutorial from './components/Tutorial/Tutorial';
import JoinByInvite from './components/Lobby/JoinByInvite';
import AdminDashboard from './components/Admin/AdminDashboard';

const router = createBrowserRouter([
  {
    path: "/",
    element: <RouteProtector/>
  },
  {
    path: "/login",
    element: <Home/>
  },
  {
    path: "/offline",
    element: <OfflineGame/>
  },
  {
    // Public on purpose: recipients of a shared link have no session yet.
    path: "/join/:inviteCode",
    element: <JoinByInvite/>
  },
  {
    // Access is enforced by the API, which checks the exact account; this route
    // only decides what to render.
    path: "/admin",
    element: <AdminDashboard/>
  },
  {
    path: "/home",
    element: <WsContainer/>,
    children: [
      {
        index: true,
        element: <Lobby/>
      },
      {
        path: "game",
        element: <Marjan/>
      },
      {
        path: "leaderboard",
        element: <Leaderboard/>
      },
      {
        path: "tutorial",
        element: <ZNKTutorial/>
      }
    ]
  }
])
function App() {
  return (
    <>
    <Provider store={store}>
    <RouterProvider router={router} />
    </Provider>
    </>
  );

}

export default App;
